<!-- eslint-disable vue/no-mutating-props -->
<template>
  <woot-modal class="contact-form-modal" :show.sync="show" :on-close="onCancel">
    <contact-form
      :in-progress="uiFlags.isCreating"
      :on-submit="onSubmit"
      @success="onSuccess"
      @cancel="onCancel"
    />
  </woot-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ContactForm from './ContactForm.vue';

export default {
  components: {
    ContactForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      createdContact: null,
    };
  },

  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
  },

  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      if (this.createdContact && this.createdContact.id) {
        this.$emit('created', this.createdContact);
      }
      this.createdContact = null;
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      this.createdContact = await this.$store.dispatch(
        'contacts/create',
        contactItem
      );
    },
  },
};
</script>
